import { QueryParamsHandling } from '@angular/router';
export interface ITableActionButton {
  id: string;
  icon: string;
  iconClass?: string;
  label?: string;
  disabled?: (item?: any, action?: ITableActionButton) => boolean;
  hidden?: (item?: any, action?: ITableActionButton) => boolean;
  tooltip?: string;
  permissionSlug?: string;
  link?: (item?: any, action?: ITableActionButton) => string;
  linkTarget?: '_blank' | '_self' | '_parent' | '_top';
  linkQueryParams?: (item?: any, action?: ITableActionButton) => { [key: string]: string };
  // showTooltip?: boolean;
  queryParamsHandling?: QueryParamsHandling;
}
